import {
    formatBot,
    formatMarkdown,
    formatSuggestionItem,
    getTemplateComponentByKeyService,
    messageFormat,
    messageToReceiveBodyHtml,
    messageToSendBodyHtml,
    playSound,
    stateMessage,
} from './formatScript';

function openCloseChat(open, id) {
    const doc = document.getElementById(id);
    doc?.setAttribute('aria-open', open ? 'true' : 'false');
}

function sendMessage(element, config, id) {
    const doc = document.getElementById(id);
    const aiAgentChatBody = doc?.querySelector('.ai-agent-chat-body');
    const aiAgentData = document.createElement('div');
    aiAgentData.classList.add('ai-agent-data');
    aiAgentData.innerHTML = messageToSendBodyHtml(
        config.sendMessage,
        config.sendIcon,
        {
            type: 'text',
            body: element.value,
        },
        new Date().toLocaleTimeString()
    );
    aiAgentChatBody?.appendChild(aiAgentData);
    element.value = '';
    aiAgentChatBody.scrollTop = aiAgentChatBody?.scrollHeight;
}

function receiveMessage(data, config, id, waiting) {
    const doc = document.getElementById(id);
    const aiAgentChatBody = doc?.querySelector('.ai-agent-chat-body');

    const firstMessage = aiAgentChatBody?.querySelector('p');

    if (firstMessage) {
        aiAgentChatBody?.removeChild(firstMessage);
    }

    const aiAgentData = document.createElement('div');
    aiAgentData.classList.add('ai-agent-data');
    aiAgentData.innerHTML = messageToReceiveBodyHtml(
        config.agentName,
        config.receiveIcon,
        data.message ? {type: 'text', body: data.message} : {type: 'text', body: data.error},
        data.time,
        waiting,
        data
    );
    aiAgentChatBody.appendChild(aiAgentData);
    aiAgentChatBody.scrollTop = aiAgentChatBody.scrollHeight;
}

async function sendMessageServer(user, agent_id = 0, session_id, message = '', testSkill = true) {
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            question: message,
            test: true,
            user,
            history: true,
            session_id: `v2-` + session_id,
            agent_id: agent_id.toString(),
        }),
    };

    if (testSkill) {
        const response = await fetch(
            `${process.env.REACT_APP_BASE_URL || window.location.origin}/api/ai_agent_v2/agent/test_agent/es`,
            fetchOptions
        );
        return await response.json();
    }

    return null;
}

async function onSubmitData(evt, config, id, params, session_id, testSkill, agent_id, user) {
    evt.preventDefault();

    const doc = document.getElementById(id);
    const aiAgentChatBody = doc?.querySelector('.ai-agent-chat-body');
    const firstMessage = aiAgentChatBody?.querySelector('p');

    if (firstMessage) {
        aiAgentChatBody?.removeChild(firstMessage);
    }

    const inputMessage = doc?.querySelector('#ai-agent-input-message');
    const message = inputMessage?.value;
    if (message.trim() === '') {
        return null;
    } else {
        sendMessage(inputMessage, config, id);
        // send message to server
        const waitDiv = document.getElementById(`ai-agent-waiting-message-${id}`);
        if (waitDiv) waitDiv.style.opacity = '1';

        const fetchOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...params,
                question: message,
                test: true,
                user,
                history: true,
                session_id: `v2-` + session_id,
                agent_id: agent_id.toString(),
            }),
        };

        if (testSkill) {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL || window.location.origin}/api/ai_agent_v2/agent/test_agent/es`,
                fetchOptions
            );
            const data = await response.json();
            // aiAgentChatBody?.removeChild(aiAgentChatBody?.lastChild);
            if (waitDiv) waitDiv.style.opacity = '0';

            receiveMessage(
                {
                    ...data?.item,
                    images: (Array.isArray(data?.item?.images)
                        ? data?.item?.images
                        : Object.values(data?.item?.images ?? {})
                    ).map((image) => `data:image/jpg;base64,${image}`),
                    message: data?.item?.message || data?.item?.error || data?.item.result,
                    time: new Date().toLocaleTimeString(),
                },
                config,
                id
            );

            const allImages = doc?.querySelectorAll('img[image-clicked]');

            allImages?.forEach((image) => {
                image.addEventListener('click', (e) => {
                    // download image
                    const link = document.createElement('a');
                    link.href = e.target.src;
                    link.download = `image-${new Date().getTime()}.jpg`;
                    link.click();
                });
            });
        } else {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL || window.location.origin}/api/ai_agent/chat_bot`,
                fetchOptions
            );
            const data = await response.json();
            // aiAgentChatBody?.removeChild(aiAgentChatBody?.lastChild);
            if (waitDiv) waitDiv.style.opacity = '0';

            receiveMessage(
                {
                    ...data,
                    message: data.message || data.result,
                    time: new Date().toLocaleTimeString(),
                },
                config,
                id
            );
        }
    }
}

function findParent(elem, keyParent) {
    let parent = elem;

    while (parent && !parent?.hasAttribute?.(keyParent)) {
        parent = parent.parentElement;
    }

    if (parent?.hasAttribute?.(keyParent)) {
        return parent;
    }

    return null;
}

function startBotContent() {
    const doc = document.getElementById('chat-bot-preview');
    doc.innerHTML = formatBotPreview(config);
    // console.log(config);
    const btnSend = doc?.querySelector('#ai-agent-id-send-submit');
    if (btnSend)
        btnSend.setAttribute('style', btnSend.getAttribute('style').concat(';right: 15px;top: calc(50% - 8px)'));

    const inputMessage = doc?.querySelector('#ai-agent-input-message');
    const btnMicro = doc?.querySelector(`#ai-agent-id-microphone-${idAgent}`);

    if (disabled_messages) {
        btnSend.setAttribute('disabled', 'true');
        inputMessage.setAttribute('disabled', 'true');
        btnMicro?.setAttribute('disabled', 'true');
    } else {
        btnSend.removeAttribute('disabled');
        inputMessage.removeAttribute('disabled');
        btnMicro?.removeAttribute('disabled');
    }

    const openAgent = document.querySelector(`#ai-agent-icon-id-open-${idAgent}`);
    openAgent?.addEventListener('click', () => openCloseChat(true, idAgent));
    const closeAgent = doc?.querySelector(`#ai-agent-icon-id-close-${idAgent}`);
    closeAgent?.addEventListener('click', () => openCloseChat(false, idAgent));
    const body = doc?.querySelector('.ai-agent-chat-body');
    const form = doc?.querySelector('#form-' + idAgent);

    const maximizeAgentOption = doc?.querySelector(`#maximize-agent-action-${idAgent}`);
    maximizeAgentOption?.addEventListener('click', () => {
        const content = document.getElementById(idAgent);
        if (content) {
            content.style.width = '100%';
            content.style.height = '100%';
        }
        document.getElementById('button-to-expand-chat')?.click();
    });

    const minimizeAgentOption = doc?.querySelector(`#minimize-agent-action-${idAgent}`);
    minimizeAgentOption?.addEventListener('click', () => {
        const content = document.getElementById(idAgent);
        if (content) {
            content.setAttribute('style', '');
        }
        document.getElementById('button-to-reduce-chat')?.click();
    });

    // console.log(form);
    form?.addEventListener('submit', (e) =>
        onSubmitData(e, config, idAgent, { agent_id }, session_id, test_skill, agent_id, user)
    );

    const messagesInit = [config?.title].map((message) => ({
        message,
        type: 'bot',
    }));
    [{ message: 'Hola', type: 'user' }, ...messagesInit].forEach((message) => {
        if (message.type === 'bot') {
            receiveMessage(
                {
                    ...message,
                    message: message.message,
                    time: new Date().toLocaleTimeString(),
                },
                config,
                idAgent
            );
        } else {
            sendMessage({ value: message.message }, config, idAgent);
        }
    });
    const suggestionContent = doc?.querySelector('.ai-agent-suggestion-content');
    const suggestions = config?.suggestedMessage;
    if (suggestions?.length) {
        suggestionContent?.querySelector('small')?.remove();
        suggestions.forEach((suggestion) => {
            const suggestionItem = formatSuggestionItem(suggestion);
            suggestionContent?.insertAdjacentHTML('beforeend', suggestionItem);
        });
    } else {
        suggestionContent.style.display = 'none';
        if (body) body.style.height = '370px';
    }
    body.scrollTop = body.scrollHeight;

    document.addEventListener('click', (e) => {
        const parent = findParent(e.target, 'ai-agent-suggestion-attr');
        if (parent) {
            const suggestionContent = doc?.querySelector('.ai-agent-suggestion-content');
            e.stopPropagation();
            parent.remove();
            const inputMessage = doc?.querySelector('#ai-agent-input-message');
            inputMessage.value = parent.textContent?.trim();
            onSubmitData(e, config, idAgent, { agent_id }, session_id, test_skill, agent_id, user_id);

            if (suggestionContent?.querySelectorAll('.ai-agent-suggestion-item').length === 0) {
                if (body) body.style.height = '370px';
                suggestionContent.style.display = 'none';
            }
        }
    });
}

function initBot(id, data, config, elementStart, domainImagesUrl, session_id, test_skill, disabled_messages, user) {
    // create script element
    const script = document.createElement('script');
    script.type = 'text/javascript';

    const botDiv = document.createElement('div');
    botDiv.id = 'chat-bot-preview';
    elementStart.appendChild(botDiv);
    script.innerHTML = stringFormatPreview(
        process.env.REACT_APP_BASE_URL || window.location.origin,
        data.id,
        domainImagesUrl,
        JSON.stringify(config),
        JSON.stringify(data),
        session_id,
        test_skill,
        disabled_messages,
        user
    );
    // important to use console.log
    script.innerHTML = script.innerHTML.replaceAll('...oo_oo', '');
    // Important to remove errors with import functions from formatScript
    script.innerHTML = script.innerHTML.replaceAll('0,_formatScript__WEBPACK_IMPORTED_MODULE_0__.', '');
    // console.log(script.innerHTML);
    elementStart.appendChild(script);
}

function stringFormatPreview(
    baseUrl,
    agentId,
    domainUrl,
    config,
    data,
    session_id,
    test_skill,
    disabled_messages,
    user
) {
    return `
        ((isPreview)=> {
            const baseUrl = "${baseUrl}";
            const domainImagesUrl = "${domainUrl}"
            let conversation = null;
            let config = ${config};
            let data = ${data};
            let session_id = ${session_id};
            let user = ${user};
            let test_skill = ${test_skill};
            let disabled_messages = ${disabled_messages};
            const audio = new Audio('${domainUrl}sounds/pop-bot.mp3');
            let recorder = null;
            let locationData = null;
            const with_assessor = false;
            with_attachment = false;
            const is_whatsapp = false;
            const is_microphone = false;
            const agent_id = ${agentId};
            const idAgent = "agent-${agentId}";
            const session = {}
            ${playSound};
            ${stateMessage};
            ${messageFormat};
            ${getTemplateComponentByKeyService}
            ${formatSuggestionItem};
            ${sendMessage};
            ${receiveMessage};
            ${formatMarkdown};
            ${messageToSendBodyHtml};
            ${messageToReceiveBodyHtml};
            ${openCloseChat};
            ${findParent};
            const formatBotPreview = ${formatBot};
            ${onSubmitData};
            const init = ${startBotContent};
            init();
        })(true);     
       `;
}

export {
    findParent,
    formatSuggestionItem,
    messageToSendBodyHtml,
    messageToReceiveBodyHtml,
    formatBot,
    openCloseChat,
    sendMessage,
    receiveMessage,
    onSubmitData,
    initBot,
    stringFormatPreview,
    sendMessageServer,
};
